import { TableAdapter } from '@makyoapp/makyo-common'

import { ActionDataType } from '@/shared/action.types'

export const getColumnInfoFromValue = (
  value: string,
  dataType: number,
  tables: TableAdapter[],
  currentTableId?: string
): { isColumn: boolean; columnName?: string; tableName?: string } => {
  if (!value || typeof value !== 'string') {
    return { isColumn: false }
  }

  const profileTable = tables.find((tb) => tb.id === window.appUserTableID)

  // Check if it's ProfileData (dataType: 2)
  if (dataType === ActionDataType.ProfileData) {
    const column = profileTable?.columns.find((c) => c.id === value)
    if (column) {
      return {
        isColumn: true,
        columnName: column.name,
        tableName: profileTable?.name || 'Profile',
      }
    }
  }

  // Check if it's ColumnData (dataType: 1) or SingleCell (dataType: 4)
  if (dataType === ActionDataType.ColumnData || dataType === ActionDataType.SingleCell) {
    const table = currentTableId ? tables.find((tb) => tb.id === currentTableId) : tables[0]
    const column = table?.columns.find((c) => c.id === value)
    if (column) {
      return {
        isColumn: true,
        columnName: column.name,
        tableName: table?.name || 'Table',
      }
    }
  }

  // Check if it's a column ID without specific dataType
  if (!dataType || dataType === 0) {
    // Check profile data columns first
    const profileColumn = profileTable?.columns.find((c) => c.id === value)
    if (profileColumn) {
      return {
        isColumn: true,
        columnName: profileColumn.name,
        tableName: profileTable?.name || 'Profile',
      }
    }

    // Check common columns
    const table = currentTableId ? tables.find((tb) => tb.id === currentTableId) : tables[0]
    const column = table?.columns.find((c) => c.id === value)
    if (column) {
      return {
        isColumn: true,
        columnName: column.name,
        tableName: table?.name || 'Table',
      }
    }
  }

  return { isColumn: false }
}
